import VLoading from 'v-loading-directive';

import { ElLoading, ClickOutside as vClickOutside } from 'element-plus';
import 'element-plus/theme-chalk/el-loading.css';


/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install(app) {
    app.directive('click-outside', vClickOutside);
    app.directive('loading', ElLoading.directive);
    app.directive('loading-render', VLoading);
  },
};

export default GlobalDirectives;
